import axios from 'axios'
// import Common from '@/components/common'
import Common from './common'
import { Message } from 'element-ui'

import { showLoading, hideLoading } from '../components/loading'
import common from './common'

window.isRefreshing = false
let refreshSubscribers = []

function subscribeTokenRefresh (cb) {
  refreshSubscribers.push(cb)
}

function onRrefreshed (token) {
  refreshSubscribers.map(cb => cb(token))
}

function requestToken () {
  return axios({
    method: 'post',
    url: `${base}api/authentication/request_token`,
    data: {
      'username': 'adks',
      'password': '12345678'
    },
    headers: {
      'Content-Type': 'application/json'
    }
  })
}
axios.interceptors.request.use(config => {
  // showLoading()
  if (config.url.lastIndexOf('api/authentication/request_token') != -1) {
    return config
  } else if (config.url.lastIndexOf('api/v1/home/GetTrueIp') != -1) {
    return config
  } else if (config.url.lastIndexOf('api/v1/home') != -1) {
    return config
  } else {
    // let token = localStorage.getItem('resToken')
    let token = Common.resToken

    if (token) {
      config.headers.Authorization = 'Bearer ' + token
      return config
    } else {
      if (!window.isRefreshing) {
        window.isRefreshing = true
        requestToken().then(r => {
          // console.log(r)
          // let token = localStorage.setItem('resToken',r)
          Common.resToken = r
          onRrefreshed(r)
          refreshSubscribers = []
          window.isRefreshing = false
        })
      }
      let retry = new Promise((resolve) => {
        /* (token) => {...}这个函数就是cb */
        subscribeTokenRefresh((t) => {
          config.headers.Authorization = 'Bearer ' + t
          /* 将请求挂起 */
          resolve(config)
        })
      })
      return retry
    }
  }
  if (config.url === 'api/v1/home') {
    return config
  } else if (config.url === 'api/authentication/request_token') {
    return config
  } else {
    let resToken = localStorage.getItem('resToken')
    if (resToken) {
      config.headers = {
        Authorization: 'Bearer ' + resToken
      }
    } else {

      // routerContent.$router.push({
      //     name: 'home',
      // })
    }
    return config
  }
}, err => {
  Message.error({ message: '请求超时!' })
})
axios.interceptors.response.use(data => {
  // if (data.status && data.status == 200 && data.data.status == 500) {
  //     Message.error({ message: data.data.msg });
  //     return;
  // }
  // if (data.data.msg) {
  //     Message.success({ message: data.data.msg });
  // }

  if (data.headers.NewToken !== undefined) {
    Common.resToken = data.headers.NewToken
    // localStorage.setItem("resToken", data.headers.NewToken)
  }

  // hideLoading()
  return data.data
}, err => {
  // hideLoading()
  if (err.response.status == 504 || err.response.status == 404) {
    Message.error({ message: '服务器被吃了⊙﹏⊙∥' })
  } else if (err.response.status == 403) {
    Message.error({ message: '权限不足,请联系管理员!' })
  } else if (err.response.status == 401) {
    Message.error({ message: err.response.data.msg })
  } else {
    if (err.response.data.msg) {
      Message.error({ message: err.response.data.msg })
    } else {
      Message.error({ message: '未知错误!' })
    }
  }
})

let base = common.http == 'http://localhost:8080/' ? '' : common.http

export const postRequest = (url, params) => {
  return axios({
    method: 'post',
    url: `${base}${url}`,
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}
export const postRequestWx = (url, params) => {
  return axios({
    method: 'post',
    url: url,
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}
export const getRequestWx = (url, params) => {
  return axios({
    method: 'get',
    url: url,
    params: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export const postRequestVisit = (url, params) => {
  return axios({
    method: 'post',
    url: `https://base2.api.bjadks.com/${url}`,
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}
export const putRequest = (url, params) => {
  return axios({
    method: 'put',
    url: `${base}${url}`,
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}
export const deleteRequest = (url) => {
  return axios({
    method: 'delete',
    url: `${base}${url}`
  })
}
export const getRequest = (url, params) => {
  // if(url.lastIndexOf("cityjson")!=-1){

  //     return axios({
  //         method: 'get',
  //         url: `${baseIp}${url}`,
  //         params: params,
  //         headers: {
  //             'Content-Type': 'application/json'
  //         }
  //     });
  // }
  return axios({
    method: 'get',
    url: `${base}${url}`,
    params: params

  })
}



// WEBPACK FOOTER //
// ./src/utils/utils.js